{
	"Features": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "Features For Page Location Services"
				},
				"title": {
					"translations": {},
					"value": "Office Location"
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.iframeSrc": {
					"translations": {},
					"value": "mapSrc"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-24 my-0"
				},
				"featureClass": {
					"translations": {},
					"value": "h-full"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "w-full my-8"
				},
				"featureTitleClass": {
					"translations": {},
					"value": "text-2xl block mb-4"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-4"
				},
				"iconClass": {
					"translations": {},
					"value": "m-2 sm:m-4"
				},
				"iframeClass": {
					"translations": {},
					"value": "w-full h-full"
				}
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "---"
			},
			"type": "TextArea",
			"value": "---"
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "locations"
		},
		"index": 0,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		},
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "We Service Locations Across Alabama"
			},
			"type": "TextArea",
			"value": "We Service Locations Across Alabama"
		}
	},
	"Features For Page Location Services": {
		"Feature 01 Address": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "العنوان المنسق",
						"en": "formattedAddress",
						"en-GB": "formattedAddress",
						"en-US": "formattedAddress",
						"es": "dirección formateada",
						"es-419": "dirección formateada",
						"es-ES": "dirección formateada",
						"he": "כתובת מעוצבת",
						"it": "Indirizzo formattato",
						"pl": "sformatowanyAdres",
						"sw": "Anwani iliyopangwa",
						"tl": "naka-format na Address",
						"vi": "Địa chỉ được định dạng",
						"zh": "格式化地址"
					},
					"value": "formattedAddress"
				},
				"title": {
					"translations": {
						"ar": "عنوان",
						"en": "Address",
						"en-GB": "Address",
						"en-US": "Address",
						"es": "DIRECCIÓN",
						"es-419": "DIRECCIÓN",
						"es-ES": "DIRECCIÓN",
						"he": "כְּתוֹבֶת",
						"it": "Indirizzo",
						"pl": "Adres",
						"sw": "Anwani",
						"tl": "Tirahan",
						"vi": "Địa chỉ",
						"zh": "地址"
					},
					"value": "Address"
				}
			}
		},
		"Feature 01 Address Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"address-card\",\"icon\":[576,512,[62140,\"contact-card\",\"vcard\"],\"f2bb\",\"M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 256l64 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-24-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm240-48l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z\"]}",
				"name": "faAddressCard"
			}
		},
		"Feature 02 Phone": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "Location.value.response-nationalPhoneNumber",
						"en": "Location.value.response-nationalPhoneNumber",
						"en-GB": "Location.value.response-nationalPhoneNumber",
						"en-US": "Location.value.response-nationalPhoneNumber",
						"es": "Ubicación.valor.respuesta-númeroteléfononacional",
						"es-419": "Ubicación.valor.respuesta-númeroteléfononacional",
						"es-ES": "Ubicación.valor.respuesta-númeroteléfononacional",
						"he": "מספר טלפון לאומי (Location.value.response-national)",
						"it": "Posizione.valore.risposta-numero di telefono nazionale",
						"pl": "Lokalizacja.wartość.odpowiedź-krajowyNumerTelefonu",
						"sw": "Nambari ya Simu ya Eneo.thamani.jibu-national",
						"tl": "Lokasyon.halaga.tugon-pambansaNumero ng Telepono",
						"vi": "Vị trí.giá trị.phản hồi-số điện thoại quốc gia",
						"zh": "Location.value.response-nationalPhoneNumber"
					},
					"value": "Location.value.response-nationalPhoneNumber"
				},
				"title": {
					"translations": {
						"ar": "الهاتف",
						"en": "Telephone",
						"en-GB": "Telephone",
						"en-US": "Telephone",
						"es": "Teléfono",
						"es-419": "Teléfono",
						"es-ES": "Teléfono",
						"he": "טֵלֵפוֹן",
						"it": "Telefono",
						"pl": "Telefon",
						"sw": "Simu",
						"tl": "Telepono",
						"vi": "Điện thoại",
						"zh": "电话"
					},
					"value": "Telephone"
				}
			}
		},
		"Feature 02 Phone Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"phone\",\"icon\":[512,512,[128222,128379],\"f095\",\"M160.2 25C152.3 6.1 131.7-3.9 112.1 1.4l-5.5 1.5c-64.6 17.6-119.8 80.2-103.7 156.4 37.1 175 174.8 312.7 349.8 349.8 76.3 16.2 138.8-39.1 156.4-103.7l1.5-5.5c5.4-19.7-4.7-40.3-23.5-48.1l-97.3-40.5c-16.5-6.9-35.6-2.1-47 11.8l-38.6 47.2C233.9 335.4 177.3 277 144.8 205.3L189 169.3c13.9-11.3 18.6-30.4 11.8-47L160.2 25z\"]}",
				"name": "faPhone"
			}
		},
		"Feature 03 Hours": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "ساعات مبسطة",
						"en": "hoursSimplified",
						"en-GB": "hoursSimplified",
						"en-US": "hoursSimplified",
						"es": "horasSimplificado",
						"es-419": "horasSimplificado",
						"es-ES": "horasSimplificado",
						"he": "שעותפשוט",
						"it": "oreSemplificate",
						"pl": "godzinyUproszczone",
						"sw": "saaIliyorahisishwa",
						"tl": "orasPinasimple",
						"vi": "giờ đơn giản",
						"zh": "小时简化"
					},
					"value": "hoursSimplified"
				},
				"title": {
					"translations": {
						"ar": "ساعات",
						"en": "Hours",
						"en-GB": "Hours",
						"en-US": "Hours",
						"es": "Horas",
						"es-419": "Horas",
						"es-ES": "Horas",
						"he": "שעות",
						"it": "Ore",
						"pl": "Godziny",
						"sw": "Saa za kazi",
						"tl": "Mga Oras",
						"vi": "Giờ",
						"zh": "小时"
					},
					"value": "Hours"
				}
			}
		},
		"Feature 03 Hours Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"clock\",\"icon\":[512,512,[128339,\"clock-four\"],\"f017\",\"M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z\"]}",
				"name": "faClock"
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureClass": {
					"translations": {},
					"value": "grid grid-cols-[auto_1fr] gap-x-2 sm:gap-x-4"
				},
				"featureContentClass": {
					"translations": {},
					"value": "col-start-2"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 gap-2 sm:gap-4"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "locations"
		},
		"hoursSimplified": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput"
		},
		"iconSize": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "2x"
		},
		"index": 1
	},
	"Location": {
		"index": 2
	},
	"PageBanner": {
		"bgImage": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "A wooden desk with a detailed city map, a magnifying glass resting on it, and a business card with the firm's name partially visible. A gavel and legal book sit nearby, symbolizing legal expertise. The softly blurred background suggests a welcoming law office with warm, professional lighting"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Flocation%2FPageBanner%2FbgImage%2FLocation%20Banner.jpg?alt=media&token=1baa81aa-e98a-46a3-81c8-0d3cd24573ca",
				"formattedSize": "106.14 KB",
				"height": 488,
				"name": "Location Banner.jpg",
				"path": "uploads/location/PageBanner/bgImage/Location Banner.jpg",
				"query": "?as=run",
				"size": 108691,
				"type": "image/jpeg",
				"updated": "2025-02-21T16:26:54.340Z",
				"width": 1588
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "w-full"
				},
				"contentClass": {
					"translations": {},
					"value": "bg-base-300 inline-block p-2 sm:p-4 md:p-6 xl:p-8 rounded mx-2 sm:mx-4"
				}
			}
		},
		"index": 3,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Criminal Lawyers Birmingham Office of Thomas Johnson Moore"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "Location"
			},
			"type": "TextInput",
			"value": "Location"
		}
	},
	"SideBySide": {
		"addressIcon": {
			"permission": "Admin",
			"translations": {},
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"address-card\",\"icon\":[576,512,[62140,\"contact-card\",\"vcard\"],\"f2bb\",\"M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 256l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z\"]}",
				"name": "faAddressCard"
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "---\n"
			},
			"type": "TextArea",
			"value": "---"
		},
		"flipped": {
			"permission": "Admin",
			"translations": {
				"en-US": "true"
			},
			"type": "TextInput",
			"value": "true"
		},
		"hoursIcon": {
			"permission": "Admin",
			"translations": {},
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"clock\",\"icon\":[512,512,[128339,\"clock-four\"],\"f017\",\"M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z\"]}",
				"name": "faClockFour"
			}
		},
		"index": 4,
		"phoneIcon": {
			"permission": "Admin",
			"translations": {},
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"phone\",\"icon\":[512,512,[128222,128379],\"f095\",\"M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z\"]}",
				"name": "faPhone"
			}
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "Title"
			},
			"type": "TextInput",
			"value": "Office Location"
		}
	}
}